import { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";

import useAxios from "../../../utils/useAxios";
import { resObj, paginationVal } from "../../../utils/constants";
import PermissionContext from "../../../context/PermissionContext";
import DrawerContext from "../../../context/DrawerContext";
import AutoLogout from "../../../utils/useAutoLogout";

import Pagination from "@mui/material/Pagination";

import SideDrawer from "../../../components/layout/SideDrawer";
import ListHeader from "../../../components/layout/ListHeader";
import CustomTable from "../../../components/layout/CustomTable";
import NoData from "../../../components/layout/NoData";
import SuccessAlert from "../../../components/layout/SuccessAlert";
import ErrorModal from "../../../components/layout/ErrorModal";
import DeleteModal from "../../../components/layout/DeleteModal";
import Loader from "../../../components/layout/Loader";

const PayloadPhaseListPage = () => {
  const api = useAxios();
  const navigate = useNavigate();

  const { permisionsList, checkUserPermission } = useContext(PermissionContext);
  const { drawerValue, setDrawerValue } = useContext(DrawerContext);

  useEffect(() => {
    if (permisionsList.length > 0) checkUserPermission(['Materials Capture-Payload Phase']);
  }, [permisionsList]);

  const [apiRes, setApiRes] = useState(resObj);
  const [payloadPhaseList, setPayloadPhaseList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [payloadId, setPayloadId] = useState('');

  const pageData = useRef({ ...paginationVal });

  const tableHeading = [
    'SI No', 'Payload Name', 'Payload Type', 'Reporter', 'Payload phase unique id',
    'Batch Number', 'Encapsulant Buffer Unique Id', 'Encapsulant Buffer Acronym'
  ];

  const deleteModalTitle = 'Payload Phase Delete';
  const deleteModalMessage = `Are you sure you want to delete? 
    (All related informations will be lost)`;

  useEffect(() => {
    getPayloadPhase();
  }, []);

  const handlePaginationClick = (e, pageNumber) => {
    pageData.current.pageNumber = pageNumber;
    getPayloadPhase();
  };

  const navigateToCreate = () => {
    navigate('/payload-phase/create');
  };

  const navigateToEdit = id => {
    navigate(`/payload-phase/edit/${id}`);
  };

  const getPayloadPhase = async () => {
    try {
      setApiRes({ ...apiRes, loading: true });
      const response = await api.get(
        '/api/materials-capture/payload-phase/list/get', {
        params: {
          search_term: pageData.current.searchTerm,
          page_number: +pageData.current.pageNumber,
        }
      });

      if (response.status === 200) {
        setApiRes({ ...apiRes, loading: false });
        setPayloadPhaseList(response.data.data);
        pageData.current.pageCount = response.data.page_count;
      }
    } catch (err) {
      setApiRes({
        ...apiRes,
        axiosError: true,
        errMsg: JSON.stringify(err.response.data).replace(/[{}[\]"']/g, ''),
        errHeading: 'Payload Phase Get',
        loading: false,
      });
    }
  };

  const deletePayloadPhase = async () => {
    try {
      setApiRes({ ...apiRes, loading: true });
      setDeleteModalOpen(false);
      const response = await api.delete(
        `/api/materials-capture/payload-phase/delete/${payloadId}`
      );

      if (response.status === 200) {
        getPayloadPhase();
        setApiRes({
          ...apiRes,
          showAlert: true,
          successMsg: 'Payload Phase deleted successfully',
          loading: false,
        });
      }
    } catch (err) {
      setApiRes({
        ...apiRes,
        axiosError: true,
        errMsg: JSON.stringify(err.response.data).replace(/[{}[\]"']/g, ''),
        errHeading: 'Payload Phase Delete',
        loading: false,
      });
    }
  };

  return (
    <AutoLogout>
      <SideDrawer drawerValue={drawerValue} setDrawerValue={setDrawerValue} />
      {apiRes.loading && <Loader />}
      <div className="mainContainer" style={{ marginLeft: drawerValue.drawerWidth }}>
        {apiRes.showAlert && <SuccessAlert apiRes={apiRes} setApiRes={setApiRes} />}
        <ListHeader
          title="Payload Phase"
          handleClick={navigateToCreate}
          search={getPayloadPhase}
          pageData={pageData}
          hasCreatePermission={permisionsList.includes('Materials Capture-Payload Phase')}
        />

        <CustomTable
          heading={tableHeading}
          rows={payloadPhaseList}
          navigateToEdit={navigateToEdit}
          setDeleteModalOpen={setDeleteModalOpen}
          setId={setPayloadId}
          pageData={pageData}
          idKey={'id'}
          isDeleteBtnVisible={permisionsList.includes('Admin-Manage Role')}
          showToolTip={false}
        />

        {payloadPhaseList.length === 0 && <NoData />}

        {(payloadPhaseList.length !== 0 && pageData.current.pageCount !== 1) && <Pagination
          style={{ marginTop: '10px', float: 'right' }}
          count={pageData.current.pageCount}
          onChange={handlePaginationClick} />}

        <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />

        <DeleteModal
          title={deleteModalTitle}
          message={deleteModalMessage}
          open={deleteModalOpen}
          setOpen={setDeleteModalOpen}
          onDelete={deletePayloadPhase}
        />
      </div>
    </AutoLogout>
  );
};

export default PayloadPhaseListPage;